<form *ngIf="configForm" [formGroup]="configForm" (ngSubmit)="onSubmit(configForm)">
    <mat-card class="content-card">
      <mat-card-header>
        <mat-card-title>
          <h5>User config</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field>
          <mat-select placeholder="Confirmation template" formControlName="confirmationTemplateId">
            <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-select placeholder="Recovery template" formControlName="recoveryTemplateId">
            <mat-option *ngFor="let template of emailTemplates" [value]="template.id">{{template.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card-content>
      <mat-card-actions align="end">
        <button mat-button type="submit" [disabled]="!configForm.valid || configForm.pristine">
          <mat-icon>done</mat-icon>
          <a>Save</a>
        </button>
      </mat-card-actions>
    </mat-card>
  </form>
